import Swal from 'sweetalert2';

const errorStore = () => {
    Swal.fire({
        title: 'Error',
        text: 'Su tienda se encuentra desactivada. Actívela para poder realizar esta acción'
    })
}

export default errorStore;